import React from 'react';
interface InfoBoxProps {
  title: string;
  value: string;
  description?: string;
  gradientFrom: string;
  gradientTo: string;
  className?: string;
}
export const InfoBox = ({
  title,
  value,
  description,
  gradientFrom,
  gradientTo,
  className = ''
}: InfoBoxProps) => {
  return <div className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradientFrom} ${gradientTo} group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300 ${className}`} data-id="element-1169">
      <div className="floating-card p-6" data-id="element-1170">
        <div className="space-y-4" data-id="element-1171">
          <h3 className="text-gray-200 font-medium text-sm" data-id="element-1172">{title}</h3>
          <p className="text-3xl font-bold text-white" data-id="element-1173">{value}</p>
          {description && <p className="text-gray-200 text-sm" data-id="element-1174">{description}</p>}
        </div>
      </div>
    </div>;
};